var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-description",class:{'base-description--no-bottom-space': _vm.noBottomSpace}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }